import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { styles } from "./styles";
import { SubscriptionTier } from "../../proto/api_pb";
import { useGetCustomerPortalLink } from "../../hooks/useGetCustomerPortalLink";
import { useContext, useState } from "react";
import { UserDetailsContext } from "../../contexts";
import { majorPlanFeatures } from "./helper";

export const MajorPlanDetails: React.FC<{ isYearly: boolean }> = ({
  isYearly,
}) => {
  const [isUpgradeSubscriptionLoading, setIsUpgradeSubscriptionLoading] =
    useState(false);
  const { subscriptionTier, stripeCustomerId } = useContext(UserDetailsContext);
  const { getCustomerPortalLink } = useGetCustomerPortalLink();

  const isUpgradePlanAvailable =
    subscriptionTier < SubscriptionTier.SUBSCRIPTION_TIER_MAJOR;

  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "40px" }} variant="h4">
          {isYearly ? "$153.99" : "$9.99"}
        </Typography>
        <Box sx={{ paddingLeft: "10px" }}>
          <Typography variant="body2" sx={{ margin: 0 }}>
            per
          </Typography>
          <Typography variant="body2">{isYearly ? "year" : "month"}</Typography>
        </Box>
      </Box>
      {isUpgradePlanAvailable && (
        <Button
          disabled={!stripeCustomerId}
          onClick={() => {
            setIsUpgradeSubscriptionLoading(true);
            getCustomerPortalLink();
          }}
          sx={{ ...styles.button, width: "100%", margin: 0 }}
        >
          {isUpgradeSubscriptionLoading || !stripeCustomerId ? (
            <CircularProgress
              sx={{ color: !stripeCustomerId ? "gray" : "black" }}
              size={22}
            />
          ) : (
            "Upgrade"
          )}
        </Button>
      )}
      <ul style={styles.majorPlanFeatureUl}>
        <li style={styles.planDetailsRow}>
          Includes all the features from the Minor plan
        </li>
        <li style={{ textAlign: "center", fontSize: "20px" }}>+</li>
      </ul>
      <ul style={styles.majorPlanFeatureUl}>
        {majorPlanFeatures.map((feature, index) => (
          <li key={index} style={styles.planDetailsRow}>
            <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
            {feature}
          </li>
        ))}
      </ul>
    </Box>
  );
};
